import { defineStore } from 'pinia'
import { asyncRouterMap, constantRouterMap } from '@/router'
// import { useRouter } from 'vue-router'
// import type { RouteRecordRaw } from 'vue-router'
import {
  generateRoutesByFrontEnd,
  generateRoutesByServer,
  flatMultiLevelRoutes
} from '@/utils/routerHelper'
import { store } from '../index'
import { cloneDeep } from 'lodash-es'
import { useUserStore } from '@/store/modules/user'
import { getPermissionsApi } from '@/api/login'


export interface PermissionState {
  routers: AppRouteRecordRaw[]
  addRouters: AppRouteRecordRaw[]
  isAddRouters: boolean
  menuTabRouters: AppRouteRecordRaw[],
  permissions: string[] | AppPermissionRecordRaw[]
}

export const usePermissionStore = defineStore('permission', {
  state: (): PermissionState => ({
    routers: [],
    addRouters: [],
    isAddRouters: false,
    menuTabRouters: [],
    permissions: []
  }),
  getters: {
    getRouters(): AppRouteRecordRaw[] {
      return this.routers
    },
    getAddRouters(): AppRouteRecordRaw[] {
      return flatMultiLevelRoutes(cloneDeep(this.addRouters))
    },
    getIsAddRouters(): boolean {
      return this.isAddRouters
    },
    getMenuTabRouters(): AppRouteRecordRaw[] {
      return this.menuTabRouters
    },
    getPermissions(): string[] | AppPermissionRecordRaw[] {
      return this.permissions
    }
    
  },
  actions: {
    setRouters(routers: AppRouteRecordRaw[]) {
      this.routers = routers
    },
    setAddRouters(addRouters: AppRouteRecordRaw[]) {
      this.addRouters = addRouters
    },
    setPermissions(permissions: string[] | AppPermissionRecordRaw[]) {
      this.permissions = permissions
    },

    async init() {
      const userStore = useUserStore()
      if(userStore.getUserInfo) {
        const res = await getPermissionsApi();
        if (res) {
          const permissions = res
          this.setPermissions(permissions || [])
          // 1 - ROUTE
          const routers = permissions?.filter(it => it.type == 1).map(it => it.code) || []
          userStore.setRoleRouters(routers)
          // await this.generateRoutes('frontEnd', routers).catch(() => {})
        } 
      }
    },

    generateRoutes(
      type: 'server' | 'frontEnd' | 'static',
      routers?: AppCustomRouteRecordRaw[] | string[]
    ): Promise<unknown> {
      return new Promise<void>((resolve) => {
        let routerMap: AppRouteRecordRaw[] = []
        if (type === 'server') {
          // 模拟后端过滤菜单
          routerMap = generateRoutesByServer(routers as AppCustomRouteRecordRaw[])
          console.log(routerMap)
        } else if (type === 'frontEnd') {
          // 模拟前端过滤菜单
          routerMap = generateRoutesByFrontEnd(cloneDeep(asyncRouterMap), routers as string[])
        } else {
          // 直接读取静态路由表
          routerMap = cloneDeep(asyncRouterMap)
        }
        // 动态路由，404一定要放到最后面
        this.addRouters = routerMap.concat([
          {
            path: '/:path(.*)*',
            redirect: '/404',
            name: '404Page',
            meta: {
              hidden: true,
              breadcrumb: false
            }
          }
        ])
        // 渲染菜单的所有路由
        this.routers = cloneDeep(constantRouterMap).concat(routerMap)
        resolve()
      })
    },
    setIsAddRouters(state: boolean): void {
      this.isAddRouters = state
    },
    setMenuTabRouters(routers: AppRouteRecordRaw[]): void {
      this.menuTabRouters = routers
    },

    reset() {
      this.setRouters([])
      this.setAddRouters([])
      this.setIsAddRouters(false)
      this.setMenuTabRouters([])
      this.setPermissions([])
    },
  },
  persist: {
    storage: sessionStorage,
    paths: ['routers', 'addRouters', 'menuTabRouters', 'permissions']
  }
})

export const usePermissionStoreWithOut = () => {
  return usePermissionStore(store)
}
